import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import store from '../../store';
import { Button, Column, Table, Form, Field } from '@smartplatform/ui';
import PollField from './PollField';
import PollResults from './PollResults';
@observer
export default class Poll extends React.Component {
	@observable poll;
	@observable editPollField;
	@observable pollFieldId;
	@observable pollField;
	@observable pollFields;
	@observable loading = true;
	@observable discussion;

	constructor(props) {
		super(props);
		this.record = props.record;
		this.init();
	}

	init = async () => {
		const { id } = this.props;
		if (!id) {
			this.loading = false;
			return;
		}
		const poll = await store.model.Poll.find({
			where: { discussionId: id },
			include: [
				{
					relation: 'fields',
					scope: {
						include: {
							relation: 'votes',
						},
					},
				},
			],
		});
		this.discussion = await store.model.Discussion.findById(this.props.id);
		this.poll = poll[0];
		this.pollFields = this.poll && (await store.model.PollField.find({ where: { pollId: this.poll.id } }));
		this.loading = false;
	};
	toggleAddPoll = async () => {
		const poll = await store.model.Poll.create({ discussionId: this.props.id });
		this.poll = poll;
		this.discussion.poll = this.poll;
		await this.discussion.save();
	};

	togglEditPollField = async id => {
		if (id) {
			this.pollFieldId = id;
		} else {
			this.pollFieldId = null;
			this.init();
		}
		this.editPollField = !this.editPollField;
	};

	computed = record => {
		return (
			<a style={{ cursor: 'pointer' }} onClick={() => this.togglEditPollField(record.id)}>
				Редактировать
			</a>
		);
	};

	onAddPoll = () => {
		this.poll.id && this.poll.save();
		this.editPollField = true;
	};

	render() {
		if (this.loading) {
			return <div>...</div>;
		}
		if (!this.props.id) {
			return (
				<div>
					<h3>Cоздайте обсуждение, чтобы добавить приложния и голосование </h3>
				</div>
			);
		}
		if (!this.poll) {
			return <Button className="btn-primary" label="Добавить опрос для обсуждения" onClick={this.toggleAddPoll} />;
		}
		return (
			<div className="poll">
				<h3>Опрос</h3>
				<Form record={this.poll} stay onDelete={this.init}>
					<Field property="name" label="Заголовок опроса" />
					<Field property="multiselect" label="Возможно несколько вариантов" />
					<h5>Варинаты ответов</h5>
					<div style={{ marginTop: '1rem' }}>
						{this.poll.id && (
							<Button label="Добавить вариант ответа" className="btn-primary" onClick={this.onAddPoll} />
						)}
					</div>
					{this.pollFields && this.pollFields.length > 0 ? (
						<Table records={this.pollFields} clickable={false}>
							<Column property="name" label="Название" />
							<Column property="user" label="Вариант пользователя" />
							<Column computed={this.computed} />
						</Table>
					) : (
						<p> Варианты ответа не добавлены добавлены</p>
					)}
				</Form>
				{this.editPollField && (
					<PollField pollId={this.poll.id} id={this.pollFieldId} onClose={() => this.togglEditPollField()} />
				)}
				{this.poll && this.poll.id && <PollResults poll={this.poll} />}
			</div>
		);
	}
}
